import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';

import {
    useShareStore,
} from '../hooks/store';
import {
    useDictionary,
} from '../hooks/config';

import Button from '@mlb/react-patterns/components/Button/button.tsx';

const ShareButton = forwardRef(({
    mediaId,
    labelKey,
    onClick,
    ...otherProps
}, ref) => {

    const dictionary = useDictionary();
    const { shareModalShow } = useShareStore();

    return (
        <Button
            label={dictionary[labelKey] ?? ''}
            handlers={
                {
                    onClick: () => {

                        shareModalShow(mediaId);

                        onClick();

                    },
                }
            }
            ref={ref}
            {...otherProps}
        />
    );

});

ShareButton.propTypes = {
    mediaId: PropTypes.string.isRequired,
    labelKey: PropTypes.string,
    onClick: PropTypes.func,
};

ShareButton.defaultProps = {
    labelKey: 'share_text',
    onClick: _noop,
};

export default ShareButton;
